import { useTranslation } from 'react-i18next';
import { useModuleStrings } from '@platform/modularity/useModuleStrings';
import { useTagsQuery } from '@platform/state/api';
import { useWorkspaceMembers } from '../../fields/options/useWorkspaceMembers';
import { fieldOptions } from './fieldOptions';
import type { IAdvancedValueProps } from './IAdvancedValueProps';

/**
 * Значення умови (прототип v4): вибір для варіантів поля («Будь-яке значення» + варіанти), учасника («Будь-хто», «Я», учасники простору),
 * тегу й так/ні; поле введення дати, числа чи тексту (рамка акценту у фокусі); для «порожнє / не порожнє» — порожня клітинка сітки.
 */
export function AdvancedValue({ ws, rt, field, kind, value, onChange }: IAdvancedValueProps) {
  const { t } = useTranslation();
  const strings = useModuleStrings();
  const members = useWorkspaceMembers(ws, kind !== 'user');
  const { data: tags = [] } = useTagsQuery(ws, { skip: kind !== 'tag' });
  if (kind === 'none') return <span aria-hidden="true" />;
  if (kind === 'text' || kind === 'number' || kind === 'date') {
    return (
      <input className="lv-adv__input" type={kind} value={value} placeholder={t('listbar.value')} aria-label={t('listbar.value')}
        onChange={(e) => onChange(e.target.value)} />
    );
  }
  const options: { value: string; label: string }[] =
    kind === 'option' ? fieldOptions(rt, field).map((o) => ({ value: o.value, label: strings.option(rt.key, field?.key ?? '', o.value, o.label) }))
      : kind === 'user' ? [{ value: 'me', label: t('listbar.me') }, ...members.map((m) => ({ value: m.user.id, label: m.user.name }))]
        : kind === 'tag' ? tags.map((tag) => ({ value: tag.name, label: tag.name }))
          : [{ value: 'true', label: t('app.yes') }, { value: 'false', label: t('app.no') }];
  const empty = kind === 'user' ? t('listbar.anyone') : t('listbar.anyValue');
  return (
    <select className="lv-select" value={value} aria-label={t('listbar.value')} onChange={(e) => onChange(e.target.value)}>
      <option value="">{empty}</option>
      {options.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
    </select>
  );
}
